import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const tabs = [
  {
    id: 'web-portal',
    icon: '💻',
    label: "Portail Web & Flux Live",
    title: "Un suivi en temps réel pour vos proches",
    content: (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <p style={{ margin: 0, fontSize: '1rem' }}>
          Lors du déclenchement de l'alerte, un lien sécurisé et crypté est instantanément envoyé à vos contacts d'urgence pré-enregistrés. Pas besoin d'application pour eux : ils accèdent directement à une plateforme web dédiée.
        </p>
        <ul style={{ paddingLeft: '20px', margin: 0, display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.95rem' }}>
          <li><strong>Localisation & Adresse :</strong> Déplacements GPS mis à jour en temps réel et traduction automatique en adresse textuelle.</li>
          <li><strong>Streaming Live :</strong> Flux vidéo et audio en direct transmis depuis votre smartphone.</li>
          <li><strong>Stabilisation Anti-Agression :</strong> Une technologie de suivi intelligent de l'image stabilise le flux vidéo en direct, même si le téléphone bouge dans tous les sens pendant une lutte.</li>
          <li><strong>Sauvegarde Cloud Cryptée :</strong> Enregistrement automatique de l'audio et de la vidéo sur des serveurs sécurisés.</li>
        </ul>
      </div>
    )
  },
  {
    id: 'community',
    icon: '👥',
    label: "Force de la Communauté",
    title: "La dissuasion par le nombre",
    content: (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <p style={{ margin: 0, fontSize: '1rem' }}>
          Prévenir ses proches est essentiel, mais ils sont parfois trop loin pour agir. C'est là que réside la véritable force de <strong>MonAlerte</strong> : la solidarité citoyenne de proximité.
        </p>
        <ul style={{ paddingLeft: '20px', margin: 0, display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.95rem' }}>
          <li><strong>Alerte de Proximité :</strong> Les utilisateurs à proximité qui possèdent l'application reçoivent une notification d'urgence locale si quelqu'un appelle à l'aide.</li>
          <li><strong>Itinéraire de Secours :</strong> S'ils acceptent d'intervenir, un itinéraire GPS en temps réel les guide directement vers la victime.</li>
          <li><strong>Synchronisation Coordonnée :</strong> La carte affiche tous les citoyens intervenants et synchronise leurs trajets pour qu'ils arrivent <strong>tous en même temps</strong>. Cet effet de groupe massif dissuade instantanément l'agresseur et le fait fuir sans violence.</li>
          <li><strong>Efficacité Collective :</strong> Plus la communauté grandit, plus le bouclier citoyen devient impénétrable.</li>
        </ul>
      </div>
    )
  },
  {
    id: 'blackbox',
    icon: '📦',
    label: "Boîte Noire Légale",
    title: "Une boîte noire pour vos droits",
    content: (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <p style={{ margin: 0, fontSize: '1rem' }}>
          Faire fuir l'agresseur est la priorité immédiate, mais il faut aussi s'assurer qu'il réponde de ses actes. Les enquêtes manquent souvent de preuves matérielles incontestables.
        </p>
        <ul style={{ paddingLeft: '20px', margin: 0, display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.95rem' }}>
          <li><strong>Historique Inviolable :</strong> Toutes les données d'alerte (GPS, heure exacte, audio, vidéo) sont cryptées en local et synchronisées de manière sécurisée.</li>
          <li><strong>Recevabilité Juridique :</strong> Le système d'historique est conçu pour devenir légalement recevable devant la justice, se comportant comme une véritable boîte noire personnelle.</li>
          <li><strong>Témoins Facilités :</strong> MonAlerte permet de recontacter facilement les citoyens qui ont accepté d'intervenir lors de l'alerte pour recueillir des témoignages précieux et structurer le dossier judiciaire.</li>
        </ul>
      </div>
    )
  },
  {
    id: 'privacy',
    icon: '🔒',
    label: "Respect de la Vie Privée",
    title: "Souveraineté et sécurité des données",
    content: (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <p style={{ margin: 0, fontSize: '1rem' }}>
          Votre sécurité ne doit pas se faire au détriment de votre vie privée. Contrairement aux solutions commerciales, le projet MonAlerte repose sur une souveraineté technologique absolue.
        </p>
        <ul style={{ paddingLeft: '20px', margin: 0, display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.95rem' }}>
          <li><strong>Chiffrement de Bout en Bout :</strong> Toutes les alertes et les données stockées sont cryptées de bout en bout. Elles sont strictement <strong>indéchiffrables</strong>, y compris pour les développeurs.</li>
          <li><strong>Zéro Service Tiers :</strong> L'application n'utilise aucun traceur publicitaire ou framework d'analyse tiers susceptible de fuiter vos données.</li>
          <li><strong>Hébergement Souverain :</strong> Toutes les données du projet sont hébergées en France, sous pavillon européen.</li>
          <li><strong>Zéro But Commercial :</strong> Vos données de déplacement et de vie ne seront jamais vendues, louées ou exploitées commercialement.</li>
        </ul>
      </div>
    )
  }
];

const AlertSystem = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const currentTab = tabs.find(t => t.id === activeTab);

  return (
    <section 
      id="features-detail" 
      className="section-padding"
      style={{
        background: 'linear-gradient(180deg, #081222 0%, #050b14 100%)',
        position: 'relative'
      }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        
        {/* Header */}
        <div className="text-center" style={{ marginBottom: '50px' }}>
          <span className="badge-gold">⚙️ Chaîne de Sécurité</span>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.8rem)',
            color: 'var(--mga-white)',
            marginTop: '10px'
          }}>
            Que se passe-t-il lors d'une <span style={{ color: 'var(--mga-gold)' }}>alerte</span> ?
          </h2>
          <p style={{
            maxWidth: '650px',
            margin: '15px auto 0 auto',
            color: 'var(--mga-slate-300)',
            fontSize: '1.05rem'
          }}>
            Découvrez comment l'écosystème MonAlerte orchestre votre protection, de la transmission vidéo à la mobilisation citoyenne.
          </p>
        </div>

        {/* Tab Buttons */}
        <div className="tab-buttons" style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          justifyContent: 'center',
          marginBottom: '35px'
        }}>
          {tabs.map(tab => {
            const isActive = tab.id === activeTab;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: '12px 24px',
                  borderRadius: '12px',
                  border: isActive ? '1px solid var(--mga-gold)' : '1px solid rgba(255,255,255,0.06)',
                  backgroundColor: isActive ? 'rgba(242, 184, 7, 0.12)' : 'rgba(11, 31, 58, 0.4)',
                  color: isActive ? 'var(--mga-gold-light)' : 'var(--mga-slate-300)',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  fontFamily: 'var(--font-display)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.25s ease'
                }}
              >
                <span>{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>

        {/* Tab Content Display */}
        <div className="glass-card" style={{
          background: 'rgba(11, 31, 58, 0.25)',
          border: '1px solid rgba(255, 255, 255, 0.05)',
          padding: '40px 35px',
          minHeight: '280px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -15 }}
              transition={{ duration: 0.3 }}
            >
              <h3 style={{
                color: 'var(--mga-white)',
                fontSize: '1.5rem',
                marginBottom: '18px',
                fontFamily: 'var(--font-display)',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <span style={{ fontSize: '1.8rem' }}>{currentTab.icon}</span>
                <span>{currentTab.title}</span>
              </h3>
              
              <div style={{ color: 'var(--mga-slate-300)', lineHeight: '1.7' }}>
                {currentTab.content}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

      </div>
    </section>
  );
};

export default AlertSystem;
